import { createJsonApiHooks } from "./useJSON";

export const {
  useAll: usePeople,
  useOne: usePerson,
  useAdd: useAddPerson,
  useUpdate: useUpdatePerson,
  useDelete: useDeletePerson,
} = createJsonApiHooks("people");